import type { EventTypeCreateDto, EventTypeDto, EventTypeUpdateDto, GetEventTypesInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventTypeService {
  apiName = 'Inventory';

  create = (input: EventTypeCreateDto) =>
    this.restService.request<any, EventTypeDto>({
      method: 'POST',
      url: '/api/inventory/event-types',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/event-types/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, EventTypeDto>({
      method: 'GET',
      url: `/api/inventory/event-types/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetEventTypesInput) =>
    this.restService.request<any, PagedResultDto<EventTypeDto>>({
      method: 'GET',
      url: '/api/inventory/event-types',
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: EventTypeUpdateDto) =>
    this.restService.request<any, EventTypeDto>({
      method: 'PUT',
      url: `/api/inventory/event-types/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
